import e from "./highrise1337.mjs";
import i from "./highrise1341.mjs";
import a from "./highrise1339.mjs";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};
